import { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("en");

  const toggleLang = () => setLang((l) => (l === "en" ? "ar" : "en"));

  useEffect(() => {
    const html = document.documentElement;
    html.lang = lang;
    html.dir = lang === "ar" ? "rtl" : "ltr";
    document.body.style.fontFamily =
      lang === "ar"
        ? "'Tajawal', 'Inter', system-ui, sans-serif"
        : "'Inter', system-ui, sans-serif";
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, isAr: lang === "ar" }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
